// extracted by mini-css-extract-plugin
export default {"info":"DeleteDocumentConfirmDialog_info__Ntzxh","deleteDocChildrenInfo":"DeleteDocumentConfirmDialog_deleteDocChildrenInfo__EPosS"};